import request from '@/CommonDP/utils/request';
// web端分享
export default {
  queryShare(id) {
    return request.get('/doc/link/share?id=' + id).then((res) => res);
  },
  getSharedetail(id) {
    return request.get('/doc/shareNew/detail?id=' + id).then((res) => res);
  },
  queryPwdShare(id, pwd) {
    return request
      .get(`/doc/link/share-pwd?id=${id}&pwd=${pwd}`)
      .then((res) => res);
  },
  getShareToken(id) {
    return request.post(`/doc/shareNew/createShareToken?id=${id}`)
      .then((res) => res);
  },
  getDownloadUrl(cnName) {
    return request
      .get(
        '/dic/get-dicContent-byName?dicCode=1000001680091756&cnName=' +
          cnName
      )
      .then((res) => res);
  },
  queryAppList(data) {
    return request.post('/app/docList', data).then((res) => res);
  },
  queryList(data) {
    return request.post('/doc/share/queryList', data).then((res) => res);
  },
  //  获取分享
  queryGetShare(pageSize, pageNum, isOut, enterpriseId) {
    return request.get(
      `/personal/doc/queryShare?pageNum=${pageNum}&pageSize=${pageSize}&isOut=${isOut}&enterpriseId=${enterpriseId}`
    );
  },
  //  取消分享
  cancelShare(param) {
    return request
      .post(`/personal/doc/cancelShare`, param)
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  },
  personalDocDeleteShare(param) {
    return request
      .post(`/doc/shareNew/myShare/delete`, param)
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  },
  queryAppPwdShare(id, pwd) {
    return request
      .get(`/doc/link/share-pwd?id=${id}&pwd=${pwd}`)
      .then((res) => res);
  },
  docShareList(id, params) {
    return request
      .post("doc/shareNew/tree?id=" + id, params)
      .then(res => res);
  }

};
